module.exports = __webpack_public_path__ + "img/web_mock.6156c887.png";